import React, { useRef } from "react";
import { DataGrid } from "devextreme-react/data-grid";
import ChartCard from "components/common/pyramid/ChartCard";

const TopIssuerEffects = ({ data }) => {
  const dataGridRef = useRef(null);
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const formatCurrency = (cellInfo) => {
    return formatter.format(cellInfo.value);
  };

  const columns = [
    {
      dataField: "Issuer",
      caption: "Issuer",
      alignment: "left",
      cellTemplate: (container, options) => {
        container.style.whiteSpace = "normal";
        container.textContent = options.text;
      },
    },
    {
      dataField: "GeoArea",
      caption: "Geo Area",
      alignment: "left",
      cellTemplate: (container, options) => {
        container.style.whiteSpace = "normal";
        container.textContent = options.text;
      },
    },
    {
      dataField: "Purchase",
      caption: "Purchase",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Sale",
      caption: "Sale",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Redemption",
      caption: "Redemption",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Pd",
      caption: "PD",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Lgd",
      caption: "LGD",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Time",
      caption: "Time",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Rating",
      caption: "Rating",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Bucket",
      caption: "Bucket",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "EclGap",
      caption: "ECL Variation",
      alignment: "right",
      customizeText: formatCurrency,
    },
  ];

  return (
    <ChartCard
      title="Top 10 Issuer Effects"
      className="pt-0 pb-3 ps-3 pe-3"
      dataGridRef={dataGridRef}
    >
      <DataGrid
        ref={dataGridRef}
        dataSource={data}
        columns={columns}
        showBorders={true}
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        allowColumnReordering={false}
        allowColumnResizing={false}
        columnAutoWidth={true}
        wordWrapEnabled={false}
        hoverStateEnabled={false}
        sorting={{ mode: "none" }}
        headerFilter={{ visible: false }}
      />
    </ChartCard>
  );
};

export default TopIssuerEffects;
